import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/tracking';
import { trackVercelPageView } from '../utils/vercelTracking';

const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Map routes to readable page names
    const getPageName = (pathname) => {
      const pathSegments = pathname.split('/').filter(Boolean);
      
      switch (pathSegments[0]) {
        case undefined:
          return 'Landing Page';
        case 'authenticate':
          return 'Authentication Page';
        case 'dashboard':
          return 'Dashboard';
        case 'add-repository':
          return 'Add Repository';
        case 'repository':
          if (pathSegments[2] === 'chat') return 'Repository Chat';
          if (pathSegments[2] === 'detail') return 'Repository Detail';
          if (pathSegments[2] === 'users') return 'User Management';
          return 'Repository Page';
        case 'account':
          return 'Account';
        default:
          return 'Unknown Page';
      }
    };

    const pageName = getPageName(location.pathname);
    const pageData = {
      path: location.pathname,
      search: location.search,
      hash: location.hash
    };
    
    // Track the pageview with both PostHog and Vercel Analytics
    trackPageView(pageName, pageData);
    trackVercelPageView(pageName, pageData);
  }, [location]);

  return null; // This component doesn't render anything
};

export default PageViewTracker; 